////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, map } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const campaignPromo = {
	[ActionsTypes.GET_CAMPAIGN_PROMO]: (state) =>
		update(state, {
			campaignPromo: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.GET_CAMPAIGN_PROMO_SUCCESS]: (state, payload) => {
		return update(state, {
			campaignPromo: {
				isLoading: {
					$set: false,
				},
				campaign: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_CAMPAIGN_PROMO_FAILURE]: (state, payload) =>
		update(state, {
			campaignPromo: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.UPDATE_CAMPAIGN_PROMO]: (state) =>
		update(state, {
			campaignPromo: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_CAMPAIGN_PROMO_SUCCESS]: (state, payload) => {
		// Put new data in store
		let current_campaigns = cloneDeep(state.scheduledPromoManager.items)

		map(current_campaigns, (elem, id) => {
			if (elem.id === payload.idCampaign) {
				current_campaigns[id] = payload.data
			}
		})
		return update(state, {
			campaignPromo: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				campaign: {
					$set: {},
				},
			},
			scheduledPromoManager: {
				items: {
					$set: current_campaigns,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_CAMPAIGN_PROMO_FAILURE]: (state, payload) => {
		const campaignState = cloneDeep(state.campaignPromo.campaign.promotionItemLines)
		const errors = payload.error.data

		/*errors.forEach(elem => {
            let idxCampaignState = findIndex(campaignState, {lineNumber: elem.lineNumber})
            campaignState[idxCampaignState].errorDto = elem
        })*/

		// Map on campaign instead of errors !
		map(campaignState, (cpn) => {
			errors.forEach((elem) => {
				if (elem.lineNumber === cpn.lineNumber) {
					cpn.errorDto = elem
				} else {
					cpn.errorDto = false
				}
			})
		})

		return update(state, {
			campaignPromo: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				campaign: {
					promotionItemLines: {
						$set: campaignState,
					},
				},
			},
		})
	},
	[ActionsTypes.CANCEL_CAMPAIGN_PROMO]: (state) =>
		update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.CANCEL_CAMPAIGN_PROMO_SUCCESS]: (state, payload) => {
		// Put new data in store
		let current_campaigns = cloneDeep(state.scheduledPromoManager.items)

		map(current_campaigns, (elem, id) => {
			if (elem.id === payload.idCampaign) {
				current_campaigns[id] = payload.data
			}
		})

		return update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				campaign: {
					$set: {},
				},
				items: {
					$set: current_campaigns,
				},
			},
		})
	},
	[ActionsTypes.CANCEL_CAMPAIGN_PROMO_FAILURE]: (state, payload) => {
		return update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},

	[ActionsTypes.CREATE_CAMPAIGN_PROMO]: (state) =>
		update(state, {
			campaignPromo: {
				isLoading: {
					$set: true,
				},
				isSuccess: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.CREATE_CAMPAIGN_PROMO_SUCCESS]: (state, _payload) => {
		return update(state, {
			campaignPromo: {
				isLoading: {
					$set: false,
				},
				isSuccess: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.CREATE_CAMPAIGN_PROMO_FAILURE]: (state, payload) => {
		const campaignState = cloneDeep(state.campaignPromo.campaign.Items)
		const errors = payload.error.data

		/*errors.forEach(elem => {
            let idxCampaignState = findIndex(campaignState, {lineNumber: elem.lineNumber})
            campaignState[idxCampaignState].errorDto = elem
        })*/

		// Map on campaign instead of errors !
		map(campaignState, (cpn) => {
			errors.forEach((elem) => {
				if (elem.lineNumber === cpn.lineNumber) {
					cpn.errorDto = elem
				} else {
					cpn.errorDto = false
				}
			})
		})

		return update(state, {
			campaignPromo: {
				isLoading: {
					$set: false,
				},
				isSuccess: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				campaign: {
					Items: {
						$set: campaignState,
					},
				},
			},
		})
	},

	[ActionsTypes.POST_CHECK_CAMPAIGN_PROMO]: (state) =>
		update(state, {
			campaignPromo: {
				isLoading: {
					$set: true,
				},
				isSuccess: {
					$set: false,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_CHECK_CAMPAIGN_PROMO_SUCCESS]: (state, payload) => {
		return update(state, {
			campaignPromo: {
				isLoading: {
					$set: false,
				},
				isSuccess: {
					$set: false,
				},
				campaign: {
					$set: payload.campaign,
				},
			},
		})
	},
	[ActionsTypes.POST_CHECK_CAMPAIGN_PROMO_FAILURE]: (state, payload) =>
		update(state, {
			campaignPromo: {
				isLoading: {
					$set: false,
				},
				isSuccess: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_CAMPAIGN_PROMO]: (state, _payload) => {
		return update(state, {
			campaignPromo: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				campaign: {
					$set: {},
				},
				update: {
					$set: false,
				},
				isSuccess: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.RESET_CAMPAIGN_PROMO_ITEMS]: (state, _payload) => {
		return update(state, {
			campaignPromo: {
				campaign: {
					$set: {},
				},
			},
		})
	},
}

export default campaignPromo
